import api from './api';

export interface Category {
  id: number;
  name: string;
  description: string;
  icon: string;
  created_at: string;
  updated_at: string;
}

export interface CategoryList {
  items: Category[];
  total: number;
}

export const categoryService = {
  async getCategories(search?: string, skip = 0, limit = 10): Promise<CategoryList> {
    let url = `/api/v1/categories_direct?skip=${skip}&limit=${limit}`;
    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }
    const response = await api.get<CategoryList>(url);
    return response.data;
  },

  async getCategory(id: number): Promise<Category> {
    const response = await api.get<Category>(`/api/v1/categories_direct/${id}`);
    return response.data;
  },
  
  async createCategory(data: { name: string; description?: string; icon?: string }): Promise<Category> {
    const response = await api.post<Category>('/api/v1/categories_direct', data);
    return response.data;
  },
};

export default categoryService; 